import React from 'react';
import { AgentLayout as Layout } from '../../components/Portal';
import MainContent from './PortalHome';
import { Grid, Typography, Card, CardContent } from "@material-ui/core";
import { asDbDDMM, errorLog } from "../../utils/commonUtils";
import { privateApi } from "../../lib/privateApi";

type TrancheProps = {
  trancheNumber: number;
  fundsDeadLineDate: string;
  projectFundingDate: string
}

const TrancheDates = () => {
  const [trancheDates, setTrancheDates] = React.useState<TrancheProps[]>([]);
  const getTranches = async () => {
    try {
      const response = await privateApi.get(`/tranche/get-upcoming-current-year-tranche`);
      setTrancheDates(response.data);
    } catch (e) {
      errorLog(e);
    }
  };

  React.useEffect(() => {
    getTranches();
  }, []);

  return (
    <Card className="boxShadow">
      <CardContent>
        {
          trancheDates.length > 0 ? (trancheDates.map(({
                                                         trancheNumber,
                                                         fundsDeadLineDate,
                                                         projectFundingDate
                                                       }, index) => {
              return (<>
                <Typography variant="subtitle1" className="mb0">T{trancheNumber} Funds/PPW
                  Deadline {asDbDDMM(fundsDeadLineDate)}</Typography>
                <Typography variant="body1" className="textLight mb20 ml10">Projected
                  funding {asDbDDMM(projectFundingDate)}</Typography>
                {index !== trancheDates.length - 1 && <span className="hLine"/>}
              </>)
            })) :
            <Typography variant="subtitle1" className="mb0">No Tranche Data Found</Typography>
        }
      </CardContent>
    </Card>
  )
};

export default () => {
  return (
    <Layout>
      <MainContent title="Tranche Dates" description="">
        <Grid container>
          <Grid item xs={12} md={12}>
            <TrancheDates/>
          </Grid>
        </Grid>
      </MainContent>
    </Layout>
  )
};
